module.exports = __webpack_public_path__ + "static/media/blog-header.ff93143c.jpg";